import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgWand = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <g>
      <path
        fill={_.color}
        fillRule="evenodd"
        d="M2.358 12.704a.63.63 0 0 0-.188.466q0 .27.18.458.187.188.466.188a.6.6 0 0 0 .465-.18l1.637-1.637a.6.6 0 0 0 .188-.45.63.63 0 0 0-.188-.466.6.6 0 0 0-.458-.188.63.63 0 0 0-.465.188zM.653 7.344a.63.63 0 0 0-.458.195.63.63 0 0 0-.195.458q0 .27.195.465a.64.64 0 0 0 .458.188h2.328a.64.64 0 0 0 .458-.188.64.64 0 0 0 .195-.465.63.63 0 0 0-.195-.458.63.63 0 0 0-.458-.196zm3.342-2.418a.62.62 0 0 0 .458.187q.277 0 .465-.187a.62.62 0 0 0 .188-.458.63.63 0 0 0-.188-.466l-1.63-1.637a.62.62 0 0 0-.457-.188.632.632 0 0 0-.653.646q0 .27.187.458zM8.657.653a.61.61 0 0 0-.195-.458A.64.64 0 0 0 7.997 0a.63.63 0 0 0-.458.195.61.61 0 0 0-.196.458v2.313q0 .27.196.465.194.196.458.196.27 0 .465-.196a.64.64 0 0 0 .195-.465zm2.418 3.349a.63.63 0 0 0-.188.466q0 .27.188.458a.62.62 0 0 0 .458.187.66.66 0 0 0 .473-.187l1.63-1.637a.63.63 0 0 0 .187-.466.63.63 0 0 0-.187-.465.62.62 0 0 0-.458-.188.62.62 0 0 0-.459.188zm2.989 11.293q.24.24.585.24.353 0 .578-.24a.8.8 0 0 0 .226-.586q0-.33-.226-.57l-7.14-7.164a.78.78 0 0 0-.586-.24q-.345 0-.57.24a.83.83 0 0 0-.233.586q0 .338.232.578zm-5.602-2.726q.195.196.195.466v2.313q0 .27-.195.458a.64.64 0 0 1-.466.195.63.63 0 0 1-.458-.195.61.61 0 0 1-.195-.458v-2.313q0-.27.195-.466a.63.63 0 0 1 .458-.195q.27 0 .466.195M15.34 8.65q.27 0 .465-.188a.64.64 0 0 0 .196-.465.63.63 0 0 0-.196-.458.64.64 0 0 0-.465-.195h-2.313a.63.63 0 0 0-.458.195.63.63 0 0 0-.195.458q0 .27.195.465a.64.64 0 0 0 .458.188z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgWand);
export default ForwardRef;
